import { render, staticRenderFns } from "./InfoHandleCourse.vue?vue&type=template&id=1b73f3c6&scoped=true"
import script from "./InfoHandleCourse.vue?vue&type=script&lang=js"
export * from "./InfoHandleCourse.vue?vue&type=script&lang=js"
import style0 from "./InfoHandleCourse.vue?vue&type=style&index=0&id=1b73f3c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b73f3c6",
  null
  
)

export default component.exports